<div class="option-wrapper d-flex align-items-center" [formGroup]="form">
    <div (click)="onChangeCheckmark($event, 'checked')" class="d-flex align-items-center cursor-pointer" style="width: 6%;">
        <div class="option-item-number">
            <span [innerText]="(7 * (pageNumber - 1)) + (idx + 1)"></span>
        </div>
        <div class="d-flex align-items-center">
            <input
                mdbCheckbox
                class="form-check-input--paybee"
                style="width: 18px; height: 18px;"
                type="checkbox"
                [checked]="transaction.checked"
            />
        </div>
    </div>
    
    <div style="width: 10%; margin-right: 15px;">
        <img [src]="imageUrl" alt="thumbnail" class="img-thumbnail p-0" style="max-width: 100%; height: auto;">
    </div>

    <div class="option-item-name" style="width: 12%; margin-right: 15px;">
        <span [innerHTML]="transaction.inKindDonationItemInfo.itemName"></span>
    </div>

    <div class="body-2" style="width: 6%; margin-right: 10px;">
        <span>{{transaction.inKindDonationItemInfo.value | currency:'USD':'symbol-narrow':'1.0-0'}}</span>
    </div>

    <div class="body-2 quill-description" style="width: 15%; margin-right: 10px;">
        {{transaction.payer.name}}
    </div>

    <!-- <div class="d-inline-flex body-2" style="width: 15%; margin-right: 10px;">
        @if (categories?.length) {
            <span [innerHTML]="categories.join(', ')"></span>
        }
    </div> -->

    <div (click)="$event.stopPropagation()" class="body-2 min-bid" style="width: 15%; margin-right: 10px;">
        <mdb-form-control class="form-fill mb-0">
            <app-mdbp-input mdbInput [isCurrencyMask]="true" formControlName="minBid" label='Starting Bid'>
                <input #inputNameC currencyMask formControlName="minBid" 
                    [options]="{ allowNegative: false, prefix: '', inputMode: 1 }" 
                    class="form-control form-control--paybee"/>
            </app-mdbp-input>
            @if(form.controls.minBid.hasError('required') && form.controls.minBid.touched) {
                <span class="form-fill-error">Provide starting bid</span>
            }
            @if(form.controls.minBid.hasError('min') && form.controls.minBid.touched) {
                <span class="form-fill-error">{{AMOUNT_LIMIT.MIN_STR}} minimum bid</span>
            }
            @if(form.controls.minBid.hasError('max') && form.controls.minBid.touched) {
                <span class="form-fill-error ml-1">{{ AMOUNT_LIMIT.GLOBAL_MAX_STR }} maximum bid</span>
            }
        </mdb-form-control>
    </div>

    <div (click)="$event.stopPropagation()" class="body-2 bid-increment" style="width: 15%; margin-right: 10px;">
        <mdb-form-control class="form-fill mb-0">
            <app-mdbp-input mdbInput [isCurrencyMask]="true" formControlName="bidIncrement" label='Bid Increment'>
                <input #inputNameC currencyMask formControlName="bidIncrement" 
                    [options]="{ allowNegative: false, prefix: '', inputMode: 1 }" 
                    class="form-control form-control--paybee"/>
            </app-mdbp-input>
            @if(form.controls.bidIncrement.hasError('required') && form.controls.bidIncrement.touched) {
                <span class="form-fill-error">Provide bid increment</span>
            }
            @if(form.controls.bidIncrement.hasError('min') && form.controls.bidIncrement.touched) {
                <span class="form-fill-error ml-1">{{AMOUNT_LIMIT.MIN_STR}} minimum bid increment</span>
            }
            @if(form.controls.bidIncrement.hasError('max') && form.controls.bidIncrement.touched) {
                <span class="form-fill-error ml-1">{{ AMOUNT_LIMIT.GLOBAL_MAX_STR }} max increment</span>
            }
        </mdb-form-control>
    </div>

    <div (click)="onChangeCheckmark($event, 'buyItNowEnabled')" class="d-flex align-items-center justify-content-center cursor-pointer" style="width: 6%; height: 18px; margin-right: 10px;">
        <input
            mdbCheckbox
            class="form-check-input--paybee"
            style="width: 18px; height: 18px;"
            type="checkbox"
            [checked]="transaction.buyItNowEnabled"
        />
    </div>

    <div (click)="$event.stopPropagation()" class="body-2 bid-increment" [class.disabled]="!transaction.buyItNowEnabled" style="width: 15%;">
        <mdb-form-control class="form-fill mb-0">
            <app-mdbp-input mdbInput [isCurrencyMask]="true" formControlName="buyItNowAmount" label='Buy it Now Amount'>
                <input #inputNameC currencyMask formControlName="buyItNowAmount" 
                    [options]="{ allowNegative: false, prefix: '', inputMode: 1 }" 
                    class="form-control form-control--paybee"/>
            </app-mdbp-input>
            @if(form.controls.buyItNowAmount.hasError('required') && form.controls.buyItNowAmount.touched) {
                <span class="form-fill-error ml-1">Provide buy now amount</span>
            }
            @if(form.controls.buyItNowAmount.hasError('min') && form.controls.buyItNowAmount.touched) {
                <span class="form-fill-error">{{AMOUNT_LIMIT.MIN_STR}} min buy now amount</span>
            }
            @if(form.controls.buyItNowAmount.hasError('max') && form.controls.buyItNowAmount.touched) {
                <span class="form-fill-error ml-1">{{ AMOUNT_LIMIT.GLOBAL_MAX_STR }} max amount</span>
            }
        </mdb-form-control>
    </div>   
</div>